import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { getAppName } from 'shared/helpers/getAppName'
import { FontHandler } from 'entities/FontPicker'

export const FontPicker = () => {
  const config = useConfigStore().config
  const isCC = useGlobalStore().isCCSelected
  const updateInterface = useConfigStore().updateInterface
  const font = config?.interfaceConfig?.[getAppName(isCC)]?.font

  return (
    <FontHandler
      key={`font_picker_${font}`}
      font={font || ''}
      updateFontHandler={updateInterface}
    />
  )
}
